import { IfStmt } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { IDatosProyectoAreaEfectivaProyecto } from 'src/app/interface/interfaces';
import { SenaceService } from 'src/app/services/senace.service';
declare const L: any;
declare const proj4: any;

@Component({
  selector: 'app-mapa',
  templateUrl: './mapa.component.html',
  styleUrls: ['./mapa.component.css']
})
export class MapaComponent implements OnInit {
  // map: any;
  map: any;
  coordenadas: any[] = [];
  poly: any;
  overlayMaps = {};
  bounds = L.latLngBounds([]);
  color: number;

  areas: IDatosProyectoAreaEfectivaProyecto[] = [];

  constructor(
    private localStorage: LocalStorage,
    private senaceService: SenaceService

  ) {

  }

  ngOnInit() {


    this.localStorage.getItem('detalle').subscribe(
      (resp: any[]) => {
        this.areas = this.senaceService.getAreaEfectiva(resp);
        this.iniciarMapa();
      }
    )
  }

  iniciarMapa() {
    let areas = this.areas;
    let center = [-9.1951786, -74.9904165]; // Centrar en PERU
    let basemap_1 = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');
    let osmAttrib = 'Map data &copy; OpenStreetMap contributors';
    let options = {
      attribution: 'Tiles courtesy of <a href="http://openstreetmap.se/" target="_blank">OpenStreetMap Sweden</a> &mdash; Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      minZoom: 0,
      maxZoom: 20
    };
    // Mapa en Miniatura
    let osmUrl = 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    let osm2 = new L.TileLayer(osmUrl, { minZoom: 0, maxZoom: 13, attribution: osmAttrib });
    var osm = L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', options);

    var osmLink = '<a href="http://openstreetmap.org">OpenStreetMap</a>',
      thunLink = '<a href="http://thunderforest.com/">Thunderforest</a>';
    var landUrl = 'https://tile.thunderforest.com/neighbourhood/{z}/{x}/{y}.png?apikey=a66ef60f8d4d4d8cb9bdeefbf93835f2',
      thunAttrib = '&copy; ' + osmLink + ' Contributors & ' + thunLink;

    // Imprimir MAPA
    this.map = L.map('map', {
      layers: [basemap_1]
    }).setView(center, 5);

    // Agregar constrol scala IZQUIERDA
    L.control.scale({
      position: 'bottomleft'
    }).addTo(this.map);



    let miniMap = new L.Control.MiniMap(osm2, { toggleDisplay: true, position: 'bottomleft', minimized: false }).addTo(this.map);
    let landMap = L.tileLayer(landUrl, { attribution: thunAttrib });

    let baseLayers = {
      "Mapa Base": basemap_1,
      "Open Street Map": osm,
      "Landscape": landMap
    };

    proj4.defs('EPSG:32717', '+proj=utm +zone=17 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs');
    proj4.defs('EPSG:32718', '+proj=utm +zone=18 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs');
    proj4.defs('EPSG:32719', '+proj=utm +zone=19 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs');
    proj4.defs('EPSG:4248', '+proj=longlat +ellps=intl +towgs84=-288,175,-376 +no_defs');


    if (areas) {
      this.color = 5;
      areas.forEach(area => {        
        let coordenadas: any[] = [];
        area.coordenadas.forEach(coordenada => {
          coordenadas.push([coordenada.este, coordenada.norte]);
        });

        const geojson = {
          'type': 'FeatureCollection',
          'crs': {
            'type': 'name',
            'properties': {
              'name': 'urn:ogc:def:crs:EPSG::327' + area.zona
            }
          },
          'features': [{
            'type': 'Feature',
            'properties': {
              'name': '',
              'id': this.color
            },
            'geometry': {
              'type': 'MultiPolygon',
              'coordinates': [[coordenadas]]
            }
          }]
        };
        this.poly = L.Proj.geoJson(geojson, {
          style: (feature) => ({
            weight: 3,
            opacity: 0.5,
            color: 'white',
            fillOpacity: 0.7,
            fillColor: this.getColor(feature.properties.id)
          })
          , onEachFeature: (feature, layer) => (
            layer.on({
              mouseover: this.highlightFeature,
              mouseout: (e) => {
                this.poly.resetStyle(e.target);
              },
              click: (e) => {
                this.map.fitBounds(e.target.getBounds());
              }
            })
          )
        }).addTo(this.map)
        .bindPopup(area.identificacion);
        this.overlayMaps['Area Efeciva ' + area.identificacion] = this.poly;

        let newcenter = (this.poly.getBounds());
        this.bounds.extend(newcenter);
        this.map.fitBounds(this.bounds);
        this.color--;
        if(this.color<=1) this.color = 5;
      });
      L.control.layers(baseLayers, this.overlayMaps).addTo(this.map)
      
    }
  }


  getColor(d: any) {
    let color = '#800026';
    if (d === 7) color = '#BD0026';
    if (d === 6) color = '#E31A1C';
    if (d === 5) color = '#FC4E2A';
    if (d === 4) color = '#FD8D3C';
    if (d === 3) color = '#FEB24C';
    if (d === 2) color = '#FED976';
    if (d === 1) color = '#FFEDA0';
    return color;
  }
  onEachFeature(feature, layer) {
    if (feature.properties && feature.properties.popupContent) {
      layer.bindPopup(feature.properties.popupContent);
    }
  }
  highlightFeature(e) {
    var layer = e.target;
    layer.setStyle({
      weight: 5,
      color: '#666',
      dashArray: '',
      fillOpacity: 0.7
    });
    if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
      layer.bringToFront();
    }
  }


}
